import { useState } from 'react';
import './style.common.scss';
import PieChart from 'app/shared/PieChart';
import { green, red, yellow, blue, gray } from 'theme/theme.constant';
import { copyVehicleNo } from 'utils/HelperFunctions';
// import { Table } from '@intellicar/phoenix-design-system';
import Table from 'app/shared/Table';
import moment from 'moment';
import { getTempBasedColor } from 'utils/HelperFunctions';
import { JSONTOCSV } from 'utils/HelperFunctions';
import { getUserInfo } from 'utils/auth';
import { ReactComponent as ExpandIcon } from 'assets/icons/expand.svg';
import { ReactComponent as DownloadIcon } from 'assets/icons/download.svg';
import SearchBox from 'app/shared/SearchBox';
import EmptyState from 'app/shared/EmptyState';
// import { JSONSearch } from 'utils/HelperFunctions';
const colors = [blue[300], green[300], yellow[300], red[300], gray[900], gray[600], gray[300]];

function FleetBattery(props) {
	const [activeTab, setActiveTab] = useState(0);
	const [openModal, setOpenModal] = useState(false);
	const [activeLegend, setActiveLegend] = useState();
	const [searchQuery, setSearchQuery] = useState('');

	const getCSVName = () => {
		let auth = getUserInfo();
		let date = moment().format('DD-MM-YYYY_h:mmA');
		return auth.username + '_Battery_Temp_' + date;
	};
	const processTableHeader = () => {
		let processed = [];
		for (let idx in props.heads) {
			let obj = {
				title: props.heads[idx].heading,
				key: props.heads[idx].key,
				sortable: true,
				dataIndex: props.heads[idx].key,
			};
			if (props.heads[idx].key === 'time') {
				obj.align = 'center';
				obj.render = (text) => {
					return (
						<div
							style={{
								display: 'flex',
								justifyContent: 'center',
								alignItems: 'center',
								// width: '100%',
							}}
						>
							<div style={{ display: 'flex', flexDirection: 'column' }}>
								<span>{moment(text).format('D MMM YYYY ')}</span>
								<span style={{ marginBottom: 2 }}>{moment(text).format('h:mm A')}</span>
							</div>
							<div
								style={{
									width: '5px',
									height: '5px',
									borderRadius: '100%',
									marginLeft: '10px',
									background: moment(text).isSame(Date.now(), 'day') ? '' : '#eb5971',
								}}
							></div>
						</div>
					);
				};
			}

			if (props.heads[idx].key === 'vehno') {
				obj.render = (text) => {
					return (
						<div
							style={{ curser: 'pointer' }}
							id={text}
							onClick={(e) => copyVehicleNo(text, e)}
							className="firstItem"
						>
							{text}
						</div>
					);
				};
			}

			if (props.heads[idx].key === 'battery_temp') {
				obj.align = 'center';
				obj.render = (text) => {
					return (
						<div
							style={{
								borderRadius: 30,
								padding: 2,
								textAlign: 'center',
								background: getTempBasedColor(text),
								width: '4rem',
								margin: 'auto',
							}}
						>
							{text}
							{props.heads[idx].unit}
						</div>
					);
				};
			}
			processed.push(obj);
		}
		return processed;
	};
	const processTableData = (source) => {
		const entries = Object.entries(props.data.history);
		const processed = {};

		entries.forEach(([idx, item]) => {
			processed[idx] =
				source === 'table'
					? {
							...item,
							key: idx,
					  }
					: {
							...item,
							key: idx,
							time: moment(item.time).format('D MMM YYYY h:mm A'),
					  };
		});

		return processed;
	};

	const getPieData = () => {
		let data = props.data.distribution;
		let pie = [];
		// eslint-disable-next-line
		for (let [key, value] in Object.entries(data)) {
			pie.push({
				id: data[key][0],
				label: data[key][0],
				value: data[key][1],
			});
		}
		return pie;
	};

	const renderView = () => {
		return activeTab === 0 ? (
			<>
				<div className="ChartArea">
					<PieChart
						data={getPieData()}
						color={colors}
						onMouseMove={(legendKey) => setActiveLegend(legendKey)}
						onMouseLeave={() => setActiveLegend('')}
					/>
				</div>
				<div className="LegendArea">
					{getPieData().map((legend, key) => {
						return (
							<div
								key={key}
								className={'Legend ' + (activeLegend === legend.label ? 'legendAnimate' : '')}
								style={{ background: activeLegend === legend.label ? colors[key] : '#f4f4f4' }}
							>
								<div className="LegendTitle">
									<i
										className="fas fa-car-battery"
										style={{ color: activeLegend === legend.label ? 'white' : colors[key] }}
									></i>
									<span style={{ color: activeLegend === legend.label ? 'white' : '#252525' }}>
										{legend.label}
									</span>
								</div>
								<div
									className="LegendValue"
									style={{ color: activeLegend === legend.label ? 'white' : '#252525' }}
								>
									{legend.value}
								</div>
							</div>
						);
					})}
				</div>
			</>
		) : (
			<div className="tableView">
				<Table
					columns={processTableHeader()}
					dataSource={processTableData('table')}
					searchQuery={searchQuery}
					searchKey={'vehno'}
					striped
					slim
					modal={openModal}
				/>
			</div>
		);
	};

	const searchTable = (key) => {
		if (key.length < 3) return;
		setSearchQuery(key);
	};

	const renderWidgetControl = () => {
		return (
			<div
				className="WidgetControl"
				style={{ justifyContent: activeTab === 1 ? 'space-between' : 'flex-end' }}
			>
				{activeTab === 1 ? (
					<div className="SearchControl">
						<SearchBox placeholder={'Search'} onSearch={searchTable} rounded on />
					</div>
				) : null}
				<div className="WidgetTab">
					<ul>
						<li onClick={() => setActiveTab(0)} className={activeTab === 0 ? 'active' : ''}>
							Chart
						</li>
						<li onClick={() => setActiveTab(1)} className={activeTab === 1 ? 'active' : ''}>
							Table
						</li>
					</ul>
				</div>
			</div>
		);
	};

	return (
		<div className="WidgetContainer">
			<div className="WidgetHeader">
				<div className="Title">Temperature Status</div>
				{props.isLive ? (
					<div className="RightControl">
						<DownloadIcon
							style={{ marginRight: 14, cursor: 'pointer' }}
							onClick={() =>
								JSONTOCSV(processTableData('download'), processTableHeader(), getCSVName())
							}
						/>
						<ExpandIcon style={{ cursor: 'pointer' }} onClick={() => setOpenModal(true)} />
					</div>
				) : null}
			</div>
			<div className="WidgetContent">
				{props.isLive ? (
					<>
						{renderWidgetControl()}
						<div className="ContentContainer">{renderView()}</div>
					</>
				) : (
					<EmptyState
						size="xs"
						title=""
						description="This data is applicable only for today's date"
					/>
				)}
			</div>
			<div className="Modal" style={{ display: openModal ? 'block' : 'none' }}>
				<div className="ModalContent">
					<div className="ModalHeader">
						<span onClick={() => setOpenModal(false)} className="close">
							&times;
						</span>
					</div>
					<span
						className="mh-download"
						style={{ position: 'relative', top: '0.5rem', float: 'right' }}
					>
						<DownloadIcon
							onClick={() =>
								JSONTOCSV(processTableData('download'), processTableHeader(), getCSVName())
							}
							style={{ marginRight: 14, cursor: 'pointer' }}
						/>
					</span>
					<div
						className="Title"
						style={{ fontWeight: 500, position: 'relative', top: '5px', width: '500px' }}
					>
						Temperature Status
					</div>
					<div className="ModalContainer">
						{renderWidgetControl()}

						<div className="WidgetView">{renderView()}</div>
					</div>
				</div>
			</div>
		</div>
	);
}

export default FleetBattery;
